// extracted by mini-css-extract-plugin
export var cardIcon = "_9l-5";
export var cardIconUnframed = "_9l-9";
export var checkboxCard = "_9l-0";
export var checkboxCardSelected = "_9l-4";
export var disabled = "_9l-2";
export var interactive = "_9l-1";
export var outerBorder = "_9l-3";
export var spacerMedium = "_9l-8";
export var spacerSmall = "_9l-7";
export var spacerXsmall = "_9l-6";